"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobsFactory = void 0;
const JobStatus_1 = require("../sub-clients/jobs/model/JobStatus");
const types_1 = require("../types");
class JobsFactory {
    static sample(job) {
        return {
            id: 'THE-ID',
            status: JobStatus_1.JobStatus.DUPLICATE,
            provider: 'TeD',
            createdAt: new Date(),
            videoSummary: {
                totalErroredVideos: 0,
                totalVideos: 1,
                totalIgnoredVideos: 0,
                totalErrors: 1,
                totalSuccessfulVideos: 1,
            },
            videos: [],
            errors: [],
            links: {
                self: new types_1.Link({ href: 'v1/jobs/the-id', templated: false }),
            },
            ...job,
        };
    }
}
exports.JobsFactory = JobsFactory;
//# sourceMappingURL=JobsFactory.js.map